module.exports = __webpack_public_path__ + "static/media/passo22.3e7980d7.jpg";